module.exports = __webpack_public_path__ + "img/得意.30bb1ddc.gif";